import { request } from '../utils/request';

export const fetchImport = params =>
  request.get('/admin/imported-data', { params });
